import React from 'react';
import './ElementSelector.css'
import { isCurrentType } from './helpers/isCurrentType';
import TypeDropdownControl from './TypeDropdownControl/TypeDropdownControl';
import TypeElementsAndOptions from './TypeElementsAndOptions/TypeElementsAndOptions';

const getClassTypeModifier = (isSelected, isHighlighted) => {
    const classes = ['element-type'];
    
    if (isSelected) {
        classes.push('element-type--active');
    } else {
        classes.push('element-type--inactive');
    }
    
    if (isHighlighted) {
        classes.push('element-type--highlighted');
    }
    
    return classes.join(' ');
}

function getTypeSelectHandler(onTypeSelect, type) {
    return () => onTypeSelect(type);
}

const TypeMapper = ({ elementTypes, prepareData, handleDragChange, attachStyleToSvg, currentType, onTypeSelect, isCheckEnabled, missingTypes,recommendedTypeChangeHandler,recommendedTypeCurrent, bodyListName, showFixedElements, toggleShowFixedElements, showSwitchButton, promotionalBannerTypeChangeHandler, promotionalBannerTypeCurrent }) => (
    elementTypes.map(type => {
        const isSelected = isCurrentType(type, currentType);
        const hightlightedElements = require('../../../assets/highlightedElements.json').highlightedElements;
        let isHighlighted = false;

        hightlightedElements.forEach(function(item) {
            if (item === type) {
                isHighlighted = true;
            }
        });

        return (
            <li
                key={type}
                className={getClassTypeModifier(isSelected, isHighlighted)}
            >

                <div className="showWhenHighlighted hidden"></div>

                <TypeDropdownControl
                    isSelected={isSelected}
                    type={type}
                    isCheckEnabled={isCheckEnabled}
                    missingTypes={missingTypes}
                    onClick={getTypeSelectHandler(onTypeSelect, type)}
                    bodyListName={bodyListName}
                    isHighlighted={isHighlighted}
                    
                />

                <TypeElementsAndOptions
                    show={isSelected}
                    type={type}
                    prepareData={prepareData}
                    handleDragChange={handleDragChange}
                    attachStyleToSvg={attachStyleToSvg}
                    recommendedTypeChangeHandler={recommendedTypeChangeHandler}
                    recommendedTypeCurrent={recommendedTypeCurrent}
                    promotionalBannerTypeChangeHandler={promotionalBannerTypeChangeHandler}
                    promotionalBannerTypeCurrent={promotionalBannerTypeCurrent}
                    showFixedElements={showFixedElements}
                    toggleShowFixedElements={toggleShowFixedElements}
                    showSwitchButton={showSwitchButton}
                />
            </li>
        )}
    )
);

const ElementSelector = (props) => (
    <ul className="element-selector">
        <TypeMapper {...props} />
    </ul>
)

export default ElementSelector;


